import React from "react"

function JumbotronDesc() {
  return (
    <div className="uk-flex uk-flex-center uk-flex-middle uk-height-1-1">
      <span className="merchandise-jumbotron-title uk-background-default">
        PO for merchandise will take 1-2 weeks
      </span>
    </div>
  )
}

export default JumbotronDesc
